import { render, staticRenderFns } from "./o-input.vue?vue&type=template&id=4189359a&scoped=true&"
import script from "./o-input.vue?vue&type=script&lang=js&"
export * from "./o-input.vue?vue&type=script&lang=js&"
import style0 from "./o-input.vue?vue&type=style&index=0&id=4189359a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189359a",
  null
  
)

export default component.exports